<div class="qe-text" [formGroup]="group">

  <p class="qe-text__intro">
    <i class="fa-solid fa-keyboard"></i>
    {{ 'QUESTION_EDITOR.ACCEPTED_ANSWERS_HINT' | translate }}
  </p>

  <div class="qe-text__list" formArrayName="answers">
    @for (answer of answers.controls; track answer; let i = $index) {
      <div class="qe-text__row">
        <span class="qe-text__index">{{ i + 1 }}</span>

        <input
          class="form-control qe-text__input"
          type="text"
          [formControlName]="i"
          [placeholder]="'QUESTION_EDITOR.ACCEPTED_ANSWER_PLACEHOLDER' | translate" />

        @if (canRemove) {
          <button
            class="qe-text__remove"
            type="button"
            [attr.aria-label]="'QUESTION_EDITOR.REMOVE_ACCEPTED_ANSWER' | translate"
            [title]="'QUESTION_EDITOR.REMOVE_ACCEPTED_ANSWER' | translate"
            (click)="removeAnswer.emit(i)">
            <i class="fa-solid fa-xmark"></i>
          </button>
        }
      </div>
    }
  </div>

  @if (canAdd) {
    <button class="qe-text__add" type="button" (click)="addAnswer.emit()">
      <i class="fa-solid fa-plus"></i>
      {{ 'QUESTION_EDITOR.ADD_ACCEPTED_ANSWER' | translate }}
    </button>
  }

  <!-- Options de comparaison -->
  <fieldset class="qe-text__options">
    <legend class="qe-text__options-title">
      {{ 'QUESTION_EDITOR.MATCH_OPTIONS' | translate }}
    </legend>

    <label class="qe-text__option">
      <input class="form-check-input" type="checkbox" formControlName="caseSensitive" />
      <span>
        <span class="qe-text__option-label">
          {{ 'QUESTION_EDITOR.CASE_SENSITIVE' | translate }}
        </span>
        <small class="qe-text__option-help">
          {{ 'QUESTION_EDITOR.CASE_SENSITIVE_HELP' | translate }}
        </small>
      </span>
    </label>

    <label class="qe-text__option">
      <input class="form-check-input" type="checkbox" formControlName="trimWhitespace" />
      <span>
        <span class="qe-text__option-label">
          {{ 'QUESTION_EDITOR.TRIM_WHITESPACE' | translate }}
        </span>
        <small class="qe-text__option-help">
          {{ 'QUESTION_EDITOR.TRIM_WHITESPACE_HELP' | translate }}
        </small>
      </span>
    </label>

    <label class="qe-text__option">
      <input class="form-check-input" type="checkbox" formControlName="normalizeArabic" />
      <span>
        <span class="qe-text__option-label">
          {{ 'QUESTION_EDITOR.NORMALIZE_ARABIC' | translate }}
        </span>
        <small class="qe-text__option-help">
          {{ 'QUESTION_EDITOR.NORMALIZE_ARABIC_HELP' | translate }}
        </small>
      </span>
    </label>
  </fieldset>

  <p class="qe-text__rule">
    <i class="fa-regular fa-circle-question"></i>
    {{ 'QUESTION_EDITOR.RULE_SHORT_TEXT' | translate: { min: minAnswers } }}
  </p>
</div>
